import {
  getPortalBranding,
  resolvePortalSourceId,
  KNOWN_APPLY_PATH_PREFIXES,
} from './portalBranding';

const FALLBACK_APPLY_PATH_PREFIX = '/apply';

// Routes.tsx's useHistory(basePath) call races the async load of the
// BoatTrader-specific source config: on the very first render basePath falls
// back to the bare '/apply' default before source.basePath
// ('/boat-loans/apply') is available, and useHistory()'s module-level
// singleton locks in whichever basename won that race for the rest of the
// page's life -- corrupting every subsequent history.push() and any URL
// built from window.location after that point. This corrects a URL/path
// built under that corruption back to the real boat-loans-proxied shape.
// Given a bare app-relative target (no apply segment of its own at all), it
// prepends the prefix outright -- correct for a fresh navigation target,
// which is never itself already prefixed.
export const buildSafeApplyHref = (pathAndSearch: string): string => {
  const url = new URL(pathAndSearch, window.location.origin);
  const sourceId = resolvePortalSourceId(url.search, url.hostname);
  const { applyPathPrefix } = getPortalBranding(sourceId);
  // Already correctly prefixed -- for the resolved portal, or for a different
  // one (e.g. the `source` param was missing/stale) -- so never double-prefix it.
  if (KNOWN_APPLY_PATH_PREFIXES.some((prefix) => url.pathname.startsWith(prefix))) {
    return url.toString();
  }
  if (
    url.pathname === FALLBACK_APPLY_PATH_PREFIX ||
    url.pathname.startsWith(`${FALLBACK_APPLY_PATH_PREFIX}/`)
  ) {
    url.pathname = url.pathname.replace(FALLBACK_APPLY_PATH_PREFIX, applyPathPrefix);
  } else {
    url.pathname = `${applyPathPrefix}${url.pathname}`;
  }
  return url.toString();
};
